import { t } from "@/i18n-js/instance";
import { ExecutePreviewCard } from "./ExecutePreviewCard";

export interface ProfileFieldExecutePreviewProps {
  field_type?: string;
  label?: string;
}

export const ProfileFieldExecutePreview = ({
  label,
  field_type,
}: ProfileFieldExecutePreviewProps) => (
  <ExecutePreviewCard
    title={t("help_widget.copilot.execute_preview.profile_field_title")}
    attributes={[
      {
        label: t("help_widget.copilot.execute_preview.name"),
        value: label,
      },
      {
        label: t("help_widget.copilot.execute_preview.field_type"),
        value: field_type,
      },
    ]}
  />
);
